import { IsDate, IsDefined, Validate } from 'class-validator';
import * as uuid from 'uuid';
import * as moment from "moment";

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { DisplayNameValidation } from 'src/core/customValidator/displayNameValidator';

export class TourItineraryProductDataService extends DataService<typeof Model.Products.Logic.ViewModels.TourItineraryProductItem, Model.Products.Logic.ViewModels.TourItineraryProductItem, TourItineraryProductItem> {
	public static make(context?: any): TourItineraryProductDataService {
		return new TourItineraryProductDataService(context, ctx => ctx.TourItineraryProducts);
	}

	public add(defaultLanguage: string, itinerary: TourItineraryItem): Promise<TourItineraryProductItem> {
		const entity = new Model.Products.Logic.ViewModels.TourItineraryProductItem();
		entity.id = uuid.v4();
		if (itinerary) {
			entity.tourItinerary = itinerary.entity;
			if (itinerary.id > 0) {
				entity.tourItineraryId = itinerary.id;
			}
		}
		if (this.items.length > 0) {
			entity.dateFrom = this.items[this.items.length - 1].dateTo;
		} else {
			entity.dateFrom = moment.utc(itinerary.entity.createdOn).hour(0).minute(0).second(0).toDate();
		}
		entity.dateTo = entity.dateFrom;

		(entity as any).dynamicProperties['displayName'] = {
			[defaultLanguage]: ''
		};
		(entity as any).dynamicProperties['translations'] = {
			[defaultLanguage]: ''
		};

		return this.create(() => entity);
	}

	public updateOrders() {
		this.items = this.items.sort((x, y) => {
			return moment.utc(x.dateFrom).isBefore(y.dateFrom)
				? -1
				: moment.utc(x.dateFrom).isAfter(y.dateFrom)
					? 1
					: moment.utc(x.dateTo).isBefore(y.dateTo)
						? -1
						: moment.utc(x.dateTo).isAfter(y.dateTo)
							? 1
							: moment.utc(x.entity.createdOn).isAfter(y.entity.createdOn)
								? 1
								: -1;
		});
	}

	protected map(entity: Model.Products.Logic.ViewModels.TourItineraryProductItem): TourItineraryProductItem {
		return new TourItineraryProductItemModel(entity);
	}
}

export class TourItineraryProductItemModel extends EntityModel<Model.Products.Logic.ViewModels.TourItineraryProductItem, TourItineraryProductItem> implements TourItineraryProductItem {
	constructor(entity: Model.Products.Logic.ViewModels.TourItineraryProductItem) {
		super(entity);
	}

	@property<TourItineraryProductItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: string;

	@property<TourItineraryProductItemModel>(o => o.entity.tourItineraryId, (o, value) => o.entity.tourItineraryId = value)
	public tourItineraryId: number;

	@property<TourItineraryProductItemModel>(o => o.entity.tourItinerary, (o, value) => o.entity.tourItinerary = value)
	public tourItinerary: any;

	@property<TourItineraryProductItemModel>(o => o.entity.productId, (o, value) => o.entity.productId = value)
	@IsDefined()
	public productId: number;

	@property<TourItineraryProductItemModel>(o => o.entity.productCategoryId, (o, value) => o.entity.productCategoryId = value)
	public productCategoryId: number;

	@property<TourItineraryProductItemModel>(o => o.entity.productServiceTypeId, (o, value) => o.entity.productServiceTypeId = value)
	@IsDefined()
	public productServiceTypeId: number;

	@property<TourItineraryProductItemModel>(o => o.entity.productServiceTypeDisplayName, (o, value) => o.entity.productServiceTypeDisplayName = value)
	public productServiceTypeDisplayName: string;

	@property<TourItineraryProductItemModel>(o => o.entity.productProviderId, (o, value) => o.entity.productProviderId = value)
	@IsDefined()
	public productProviderId: number;

	@property<TourItineraryProductItemModel>(o => o.entity.productProviderApiName, (o, value) => o.entity.productProviderApiName = value)
	public productProviderApiName: string;

	@property<TourItineraryProductItemModel>(o => o.entity.productProviderName, (o, value) => o.entity.productProviderName = value)
	public productProviderName: string;

	@property<TourItineraryProductItemModel>(o => o.entity.supplierId, (o, value) => o.entity.supplierId = value)
	@IsDefined()
	public supplierId: number;

	@property<TourItineraryProductItemModel>(o => o.entity.supplierTitle, (o, value) => o.entity.supplierTitle = value)
	public supplierTitle: string;

	@property<TourItineraryProductItemModel>(o => o.entity.supplierDefaultCurrencyIso3Name, (o, value) => o.entity.supplierDefaultCurrencyIso3Name = value)
	public supplierDefaultCurrencyIso3Name: string;

	@property<TourItineraryProductItemModel>(o => o.entity.productType, (o, value) => o.entity.productType = value)
	public productType: number;

	@property<TourItineraryProductItemModel>(o => o.entity.createdOn, (o, value) => o.entity.createdOn = value)
	public createdOn: Date;

	@property<TourItineraryProductItemModel>(o => o.entity.dateFrom, (o, value) => o.entity.dateFrom = value)
	@IsDefined()
	@IsDate()
	public dateFrom: Date;

	@property<TourItineraryProductItemModel>(o => o.entity.dateTo, (o, value) => o.entity.dateTo = value)
	@IsDefined()
	@IsDate()
	public dateTo: Date;

	@property<TourItineraryProductItemModel>(o => o.entity.isRequired, (o, value) => o.entity.isRequired = value)
	public isRequired: boolean;

	@property<TourItineraryProductItemModel>(o => o.entity.location, (o, value) => o.entity.location = value)
	public location: any;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	@Validate(DisplayNameValidation, ['en'])
	public dynamicProperties: {};
}



// WEBPACK FOOTER //
// ./src/app/products/tour-itineraries/form/tour-itinerary-product.data.ts